import { takeEvery, put, call } from 'redux-saga/effects';
import type { SagaReturnType } from 'redux-saga/effects';
import { documentBundleActions } from 'src/redux/actions/constant';
import documentBundleService from 'src/services/apiServices/document-bundle/document-bundle-service';

const {
  REQUEST_SUBMIT_DOWNLOAD_JOB,
  SUCCESS_SUBMIT_DOWNLOAD_JOB,
  FAILURE_SUBMIT_DOWNLOAD_JOB,
  LOADING_SUBMIT_DOWNLOAD_JOB,
} = documentBundleActions;

function* submitDownloadJob(action: any): SagaReturnType<any> {
  try {
    yield put({ type: LOADING_SUBMIT_DOWNLOAD_JOB });
    const response = yield call(documentBundleService.submitDownloadJob, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_SUBMIT_DOWNLOAD_JOB, payload: response.data?.data });
    } else {
      throw response?.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_SUBMIT_DOWNLOAD_JOB, payload: error });
  }
}

function* submitDownloadJobSaga() {
  yield takeEvery(REQUEST_SUBMIT_DOWNLOAD_JOB, submitDownloadJob);
}

export default submitDownloadJobSaga;
export { submitDownloadJob };
